import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-green text-ivory mt-0">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-24 pb-10">
        <div className="grid md:grid-cols-12 gap-14 pb-20 border-b border-ivory/15">
          <div className="md:col-span-5">
            <p className="eyebrow text-ivory/50 mb-6">Capstone Hats LTD</p>
            <p className="font-serif text-4xl sm:text-5xl leading-[1.15]" data-testid="footer-tagline">
              Tradition in <span className="italic text-honey">every stitch.</span>
            </p>
            <p className="mt-8 text-sm text-ivory/60 leading-relaxed max-w-sm">
              Premium tweed and wax cotton hats, made in the United Kingdom
              using traditional methods.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="eyebrow text-ivory/50 mb-6">Explore</p>
            <ul className="space-y-3">
              {[
                { to: "/", label: "Home" },
                { to: "/gallery", label: "Gallery" },
                { to: "/wholesale", label: "Wholesale" },
                { to: "/about", label: "About" },
                { to: "/coming-soon", label: "New Brand" },
                { to: "/contact", label: "Contact" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="nav-link text-sm text-ivory/80 hover:text-ivory transition-colors duration-300"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="eyebrow text-ivory/50 mb-6">Correspondence</p>
            <a
              href="mailto:Capstonehatsltd@gmail.com"
              data-testid="footer-email-link"
              className="group flex items-center gap-2 font-serif text-lg mb-4 hover:text-honey transition-colors duration-300"
            >
              Capstonehatsltd@gmail.com
              <ArrowUpRight size={16} className="opacity-50 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300" />
            </a>
            <a
              href="tel:07853180424"
              data-testid="footer-phone-link"
              className="group flex items-center gap-2 font-serif text-lg hover:text-honey transition-colors duration-300"
            >
              07853 180 424
              <ArrowUpRight size={16} className="opacity-50 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300" />
            </a>
          </div>
        </div>
        <div className="pt-8 flex flex-col sm:flex-row justify-between gap-3">
          <p className="eyebrow !text-[0.6rem] text-ivory/40">
            © {new Date().getFullYear()} Capstone Hats LTD
          </p>
          <p className="eyebrow !text-[0.6rem] text-ivory/40">
            Made in the United Kingdom
          </p>
        </div>
      </div>
    </footer>
  );
}
